import { Box, Button, Grid, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { CustomPaper } from "../../../../../../../../../../components/CustomPaper"
import { PropsRight } from "./types"
import { DestinationType } from "../../../create/enums/destinationType"
import { InputModal } from "../../../create/components/inputModal"
import { CustomTable } from "../../../../../../../../../../components"
import { CustomeIconButton } from "../../../../../../../../../../components/customeIconButton"
import { DinamicForm } from "../../../../../../../../../../components/dinamicForm"
import { icons } from "../../../../../../../../../../utils/icons"
import React, { useEffect, useState } from "react"
import { CaptionKey } from "../../../../../../../../../../components/detailKeyValue/keyCaption.index"
import { ListTooltipDetail } from "../../../../../../../../../../components/listTooltipDetail"
import { MapActivity } from "../../../../../mapActivity"
import { Roles } from "../../../../../../../../../../utils/enums"
import { Destination, Local } from "../../../create/types"
import { getLocalStorage } from "../../../../../../../../../../utils/crud/crypt"
import { PopoverButtons } from "../../../../../../../../../../components/buttons/popoverButtons"
import SimpleModal from "../../../../../../../../../../components/modal/simpleModal"
import { DestinationModal } from "../../../create/components/destinationModal"


const Right = React.memo((props: PropsRight) => {
    const { t } = useTranslation()
    const styles = useStyles()
    const [openUnityModal, setOpenUnityModal] = useState(false)
    const [openDestinatioModal, setOpenDestinatioModal] = useState(false)
    const [openUserModal, setOpenUserModal] = useState(false)
    const [selectedPoint, setSelectedPoint] = useState<{ lat: number; lng: number } | null>(null);
    const [destinationFinalCopy, setDestinationFinalCopy] = useState<Destination | undefined>(undefined)
    const [value, setValue] = useState<{ name: string, direction: string, company?: { label: string, value: number } }>({ name: '', direction: '', company: undefined })
    const company: Local = getLocalStorage()
    const [id, setId] = useState<number>()
    const [openDestinatioModalRegitred, setOpenDestinatioModalRegistred] = useState(false)
    const allDestionatiosList = [...props.destinatioCreated]
    //const disableDestinationForm = useMemo(() => generalDisabled(props.inputDestination, props.dataDestination), [props.dataDestination])
    const [disableName, setDisableName] = useState(false)
    const closeModal = () => {
        setOpenUnityModal(false)
        setOpenDestinatioModal(false)
        setOpenUserModal(false)
        setOpenDestinatioModalRegistred(false)
        props.filterUnity.cleanFilter()
    }

    const handleCancelUnity = () => {
        closeModal()
        props.setDestinationFinal(destinationFinalCopy)
    }

    const handleMapClick = (lat: number, lng: number) => {
        setSelectedPoint({ lat, lng });
    };

    const handleCloseUnity = () => {
        closeModal()
        props.setUnityToDestination()
        props.setEdit(true)
    }

    const handleSetDestination = ({ edit }: { edit: boolean }) => {
        closeModal()
        props.setEdit(true)
        if (!edit) {
            handleToCreateDestination()
        } else {
            handleToEditDestination()
        }
    }

    const handleToCreateDestination = () => {
        const localId = Date.now()
        setId(localId)

        props.setDestinationFinal({
            id: null,
            latitude: selectedPoint?.lat ?? 0,
            longitude: selectedPoint?.lng ?? 0,
            name: value.name,
            compnayId: value.company?.value,
            direction: value.direction,
            type: DestinationType.DESTINATION,
            companyName: value.company?.label,
            idDestnation: localId,
            toCreate: false,
            toCreateSelected: false
        })

    }

    const handleToEditDestination = () => {

        props.setDestinationFinal(prev => ({
            ...prev,
            id: null,
            latitude: selectedPoint?.lat ?? 0,
            longitude: selectedPoint?.lng ?? 0,
            name: value.name,
            compnayId: value.company?.value,
            direction: value.direction,
            type: DestinationType.DESTINATION,
            companyName: value.company?.label,
            toCreate: true,
            toCreateSelected: false
        }))

    }


    const handleSetDestinationSelected = ({ id, latitude, longitude, name, direction }: { direction: string, name: string, id?: number | null, latitude: number, longitude: number }) => {
        props.setDestinationFinal({
            id: null,
            latitude: latitude,
            longitude: longitude,
            name: name,
            compnayId: undefined,
            direction: direction,
            type: DestinationType.DESTINATION,
            companyName: undefined,
            idDestnation: id,
            toCreate: false,
            toCreateSelected: true
        })
        closeModal()
    }

    const handleSetUser = () => {
        props.setUserToFinal()
        closeModal()
    }

    const handleEditUnity = (create: boolean) => {
        setOpenUnityModal(true);
        if (create) {
            props.setDestination(undefined)
            setDestinationFinalCopy(props.destinationFinal)
            props.setDestinationFinal(undefined)
        } else {
            props.setDestination(props.destinationFinal)
            setDestinationFinalCopy(props.destinationFinal)
        }

        props.filterUnity.cleanFilter()
        if (company.role !== Roles.ADMIN) {
            props.filterUnity.onChange({ target: { name: 'onlyHierarchy', value: true } })
        }
        props.setOldTypeDestination(DestinationType.DESTINATION)
    }

    const handleEditDestination = (create: boolean) => {
        setOpenDestinatioModal(true);
        if (create) {
            props.setOldTypeDestination(DestinationType.UNITY)
            setValue({ name: '', direction: '', company: undefined })
            setSelectedPoint(null)
        } else {
            props.setOldTypeDestination(DestinationType.DESTINATION)
            setValue({ name: props.destinationFinal?.name ?? '', direction: props.destinationFinal?.direction ?? '', company: props.destinationFinal?.compnayId ? { label: props.destinationFinal?.companyName ?? '', value: props.destinationFinal?.compnayId } : undefined })
        }
    }

    const handleEditDestinationSelected = (create: boolean) => {
        setOpenDestinatioModalRegistred(true);

        if (create) {
            setDestinationFinalCopy(props.destinationFinal)
            props.setOldTypeDestination(DestinationType.UNITY)
            props.setDestinationFinal(undefined)
        } else {
            props.setOldTypeDestination(DestinationType.DESTINATION)
            setDestinationFinalCopy(props.destinationFinal)
        }
    }

    const handleCancelSelectDestination = () => {
        setOpenDestinatioModalRegistred(false);

        props.setDestinationFinal(destinationFinalCopy)
    }

    const handleEditUser = () => {
        setOpenUserModal(true);
        props.setUser(props.userFinal)
        /* props.setDestination(props.destinationFinal) */
        props.filter.cleanFilter()
    }

    /* setSelectedPlace */

    const handlePlaceSelect = (place: google.maps.places.PlaceResult | null) => {
        if (place?.geometry?.location) {
            setSelectedPoint({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });
        }
    };

    useEffect(() => {
        if (props.destinationFinal?.type == DestinationType.DESTINATION) {
            //props.handleDataDestination({ title: props.destinationFinal.name })
            //setValue(props.destinationFinal.name)
            setValue({ name: props.destinationFinal?.name ?? '', direction: props.destinationFinal?.direction ?? '', company: (props.destinationFinal?.companyName && props.destinationFinal.compnayId) ? { label: props.destinationFinal?.companyName, value: props.destinationFinal?.compnayId } : undefined })
            setSelectedPoint({ lat: props.destinationFinal.latitude, lng: props.destinationFinal.longitude })
        }
    }, [props.destinationFinal])

    return (
        <Box sx={styles.body}>
            {!props.isPartner &&
                <Box sx={styles.child}>
                    <Typography variant="title_grey_dark">{t('loogbook.titles.userRequired')}</Typography>

                    <Box>
                        <CustomPaper sx={styles.userContainer} elevation={3}>

                            <Grid container spacing={2}>
                                <Grid item xs={12} >
                                    <CaptionKey value={t('general.tags.name')} caption={props.userFinal?.name} />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                                    <CaptionKey value={t('general.tags.role')} caption={props.userFinal?.role ?? 'N/A'} />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                                    <CaptionKey value={t('general.tags.division')} caption={props.userFinal?.division ?? 'N/A'} />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                                    <CaptionKey value={t('general.tags.area')} caption={<ListTooltipDetail list={props.userFinal?.area || []} />} />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                                    <CaptionKey value={t('general.tags.department')} caption={<ListTooltipDetail list={props.userFinal?.department || []} />} />
                                </Grid>
                            </Grid>

                        </CustomPaper>
                        <Button onClick={handleEditUser}>{t('loogbook.titles.changeUser')}</Button>
                    </Box>
                </Box>
            }

            <Box sx={styles.child}>
                <Typography variant="title_grey_dark">{t('loogbook.titles.destinationRequired')}</Typography>

                <Box>
                    <CustomPaper sx={styles.destinationContainer} elevation={3}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                                <CaptionKey value={t('general.tags.name')} caption={props.destinationFinal?.name ?? 'N/A'} />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
                                <CaptionKey value={t('general.tags.latitude')} caption={String(props.destinationFinal?.latitude) ?? 'N/A'} />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
                                <CaptionKey value={t('general.tags.longitude')} caption={String(props.destinationFinal?.longitude) ?? 'N/A'} />
                            </Grid>
                            {props.destinationFinal?.direction &&
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={props.destinationFinal?.compnayId ? 6 : 12}>
                                    <CaptionKey value={t('loogbook.direction')} caption={props.destinationFinal.direction ?? 'N/A'} />
                                </Grid>
                            }
                            {props.destinationFinal?.compnayId &&
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                                    <CaptionKey value={t('loogbook.company')} caption={props.destinationFinal.companyName ?? 'N/A'} />
                                </Grid>
                            }
                        </Grid>
                    </CustomPaper>

                    <Box sx={styles.buttonWithoutBorder}>
                        <Button
                            onClick={() => {
                                if (props.destinationFinal) {
                                    props.destinationFinal.type === DestinationType.DESTINATION
                                        ?
                                        props.destinationFinal.toCreateSelected ?
                                            handleEditDestinationSelected(false)
                                            :
                                            handleEditDestination(false)
                                        : handleEditUnity(false);
                                } else {
                                }
                            }}
                        >
                            {props.destinationFinal?.type == DestinationType.DESTINATION ? t('loogbook.buttons.editDestination') : t('loogbook.buttons.editUnity')}
                        </Button>
                        <PopoverButtons
                            buttonLabel={t('loogbook.buttons.change')}
                            list={
                                props.destinationFinal?.id
                                    ? [
                                        {
                                            action: () => handleEditDestination(true),
                                            disable: false,
                                            label: t('loogbook.buttons.create'),
                                        },
                                        {
                                            action: () => handleEditDestinationSelected(true),
                                            disable: false,
                                            label: t('loogbook.buttons.destionationRegister'),
                                        },
                                    ]
                                    : props.destinationFinal?.idDestnation && !props.destinationFinal?.toCreateSelected
                                        ? [
                                            {
                                                action: () => handleEditUnity(true),
                                                disable: false,
                                                label: t('loogbook.buttons.selectUnity'),
                                            },
                                            {
                                                action: () => handleEditDestinationSelected(true),
                                                disable: false,
                                                label: t('loogbook.buttons.selectDestination'),
                                            },
                                        ]
                                        : [
                                            {
                                                action: () => handleEditUnity(true),
                                                disable: false,
                                                label: t('loogbook.buttons.selectUnity'),
                                            },
                                            {
                                                action: () => handleEditDestination(true),
                                                disable: false,
                                                label: t('loogbook.buttons.createDestination'),
                                            },
                                        ]
                            }
                            styleType
                        />
                        {/* <Button
                            onClick={() => {
                                if (props.destinationFinal) {
                                    props.destinationFinal.type === DestinationType.DESTINATION
                                        ? handleEditDestination(false)
                                        : handleEditUnity();
                                } else {

                                }
                            }}
                        >
                            {props.destinationFinal?.type == DestinationType.DESTINATION ? t('loogbook.buttons.editDestination') : t('loogbook.buttons.editUnity')}
                        </Button>
                        <Button
                            onClick={() => {
                                if (props.destinationFinal) {
                                    props.destinationFinal.type === DestinationType.UNITY
                                        ? handleEditDestination(true)
                                        : handleEditUnity()
                                } else {

                                }
                            }}
                        >{props.destinationFinal?.type == DestinationType.DESTINATION ? t('loogbook.buttons.selectUnity') : t('loogbook.buttons.createDestination')}</Button> */}
                    </Box>
                </Box>
            </Box>

            <InputModal
                open={openUnityModal}
                title={t('stores.filter.inputs.search')}
                cancelText={t('general.cancel')}
                buttonText={t('loogbook.buttons.select')}
                disableButton={!props.destination}
                back={handleCancelUnity}
                next={handleCloseUnity}
                children={<>
                    <Box sx={styles.filters}>
                        {!!props.filterUnity.counter && (<CustomeIconButton icon={icons('clean')} title={t('ToolTips.clearFilters')} iconButtonProps={{ sx: styles.cleanFilters, onClick: () => { props.filterUnity.cleanFilter() } }} />)}
                        <DinamicForm input={Object.values(props.inputFilterUnity)} values={props.filterUnity.filterData} onChange={props.filterUnity.onChange} />
                    </Box>

                    <Box sx={styles.table({ row: !!props.tableUnits.row.length })}>
                        <CustomTable
                            name={'Table'}
                            tableRadio
                            tableChecks
                            dontRefresh
                            column={props.tableUnits.column}
                            defaultChecks={[Number(props.destination?.id)]}
                            row={props.tableUnits.row}
                            onClick={(e) => { props.handleRowClickUnity(e.checks[0]); }}
                            selected={-1}
                            loader={props.loading.units}
                            serverSidePagination={{ page: props.filterUnity.paginationModel.page + 1, size: props.filterUnity.paginationModel.pageSize, totalPages: props.totalPages }}
                            handleChange={(page: number, pageSize: number) => {
                                props.filterUnity.handlePagination({ page, pageSize })
                            }}
                        />
                    </Box>
                </>}
            />

            <InputModal
                open={openDestinatioModal}
                title={undefined}
                cancelText={t('general.cancel')}
                buttonText={(props.destinationFinal?.type == DestinationType.DESTINATION && !props.destinationFinal.toCreateSelected) ? t('loogbook.titles.editDestination') : t('loogbook.titles.createDestination')}
                back={closeModal}
                next={() => { handleSetDestination({ edit: props.destinationFinal?.type == DestinationType.DESTINATION }) }}
                disableButton={(!company.company && !value.company && company.role == Roles.ADMIN) || value.direction.trim()?.length < 3 || value.name.trim()?.length < 3 || !selectedPoint}
                sx={styles.mapModal}
                hideClose
                children={
                    <Box sx={styles.map}>
                        <MapActivity
                            defaultCenter={{ lat: selectedPoint ? selectedPoint.lat : 37.7749, lng: selectedPoint ? selectedPoint.lng : -122.4194 }}
                            defaultZoom={14}
                            selectedPoint={selectedPoint}
                            onMapClick={handleMapClick}
                            onPlaceSelect={handlePlaceSelect}
                            value={value}
                            setValue={setValue}
                            compnayId={company.company?.id}
                            role={company.role}
                            companies={props.companies}
                            title={props.destinationFinal?.type == DestinationType.DESTINATION ? t('loogbook.titles.editDestination') : t('loogbook.titles.createDestination')}
                        />
                    </Box>
                }
            />

            <InputModal
                open={openDestinatioModalRegitred}
                title={undefined}
                cancelText={undefined}
                buttonText={undefined}
                back={() => { }}
                next={() => { }}
                disableButton={undefined}
                sx={styles.mapModal}
                hideClose
                hiddenFooterButton
                children={
                    <Box sx={styles.map}>
                        <DestinationModal
                            cancel={handleCancelSelectDestination}
                            confirm={handleSetDestinationSelected}
                            destinations={allDestionatiosList}
                            destinationSelected={
                                props.destinationFinal ? {
                                    latitude: props.destinationFinal.latitude,
                                    longitude: props.destinationFinal.longitude,
                                    id: props.destinationFinal.idDestnation,
                                    direction: props.destinationFinal.direction ?? '',
                                    name: props.destinationFinal.name
                                } : null
                            }
                        />
                    </Box>
                }
            />

            <InputModal
                open={openUserModal}
                title={t('loogbook.titles.changeUser')}
                cancelText={t('general.cancel')}
                buttonText={t('general.save')}
                back={closeModal}
                next={handleSetUser}
                disableButton={!props.user}
                children={<>
                    <Box sx={styles.filters}>
                        {!!props.filter.counter && (<CustomeIconButton icon={icons('clean')} title={t('ToolTips.clearFilters')} iconButtonProps={{ sx: styles.cleanFilters, onClick: () => { props.filter.cleanFilter() } }} />)}
                        <DinamicForm input={Object.values(props.inputFilter)} values={props.filter.filterData} onChange={props.filter.onChange} />
                    </Box>

                    <Box sx={styles.table({ row: !!props.tableUsers.row.length })}>
                        <CustomTable
                            name={'Table'}
                            dontRefresh
                            tableChecks
                            loader={props.loading.users}
                            column={props.tableUsers.column}
                            row={props.tableUsers.row}
                            onClick={(e) => { props.handleRowClickUser(e.checks[0]); }}
                            defaultChecks={[Number(props.user?.id)]}
                            selected={-1}
                            tableRadio={true}
                        />
                    </Box>
                </>
                }
            />
        </Box>
    )
})

export { Right }